import { defineStore } from 'pinia'
import { useSyncData } from '@/composables/useSyncData'
import type { Segment } from '@/_api/models/segment'

export const useSegmentStore = defineStore('segment', () => {
  const { $api, $grants, $features } = useNuxtApp()
  const authStore = useAuthStore()

  const accountId = computed(() => authStore.activeGuid)

  const {
    items: segments,
    count,
    hydrated,
    syncState,
    isSyncing,
    syncProgress,
    sync: _sync,
    findById,
  } = useSyncData<Segment>({
    service: $api.segment,
    key: 'segments',
    accountId,
    grants: { segment: ['view'] },
  })

  const sync = async (options?: { force?: boolean; change?: boolean }) => {
    if ($features && !$features.get('segments')) {
      return
    }

    if ($grants && !$grants.all({ segment: ['view'] })) {
      return
    }

    await _sync(options)
  }

  const syncDate = computed(() => syncState.value.date)

  const all = computed(() => segments.value)

  return {
    segments,
    count,
    hydrated,
    syncState,
    isSyncing,
    syncProgress,
    syncDate,
    sync,
    findById,
    all,
  }
})
